import { Filter } from './filter.class';
import { Sorter } from './sorter.class';
import { AbstractTable, TableArgs, IAbstractCol, ColsArgs } from '../abstract/table.class';
import { Chain } from '../../chain.class';
import { LocalMenu } from './menu/menu.component';
import { DefaultSort } from '../abstract/sorter.class';
import { SorterFn } from '../../../../utils/sorter.class';


export interface LocalCol<D extends object> extends IAbstractCol<D> {
   sorter?: SorterFn<D>;
}


export interface LocalColArgs<D extends object> extends ColsArgs<D> {
   templates: {
      [id: string]: LocalCol<D>;
   }
}


export interface LocalTableArgs<D extends object> extends TableArgs<D> {
   defaultSort: DefaultSort;
   cols: LocalColArgs<D>;
}




export class LocalTable<D extends object> extends AbstractTable<D> {
   readonly chain: Chain<D>;
   readonly sorter: Sorter<D>;
   readonly filter: Filter<D>;
   readonly menu: LocalMenu;

   constructor(args: LocalTableArgs<D>) {
      super(args);
      this.filter = new Filter(this);
      this.sorter = new Sorter(this, args.defaultSort);
      this.menu = new LocalMenu(this);
      this.chain = new Chain({
         isAlive: this.dom.isAlive,
         source: this.source,
         rings: [this.filter, this.sorter, this.selection, this.rows]
      });
   }
}
